// Auto-generated from Contentful export - DO NOT EDIT MANUALLY
// Generated on: 2026-01-14T06:32:21.756Z

export const newsItemsData = [
  {
    id: '62udHcE4XJbTEBl73qlGdK',
    internalTitle: 'How a data exchange platform eases data integration',
    title: 'How a data exchange platform eases data integration',
    publishDate: '2024-06-06',
    url: 'https://www.infoworld.com/article/3715419/how-a-data-exchange-platform-eases-data-integration.html',
    image: {
      url: '/img/contentful/3Pm8bhBS-ifw_logo_social_300x300.webp',
      file: {
        url: '/img/contentful/3Pm8bhBS-ifw_logo_social_300x300.webp'
      }
    }
  },
  {
    id: '5WDroxGexN4Z7MP2UGs16g',
    internalTitle:
      'DZone - Bridging the Gap: Exploring Innovative Paths in Data Integration',
    title: 'Bridging the Gap: Exploring Innovative Paths in Data Integration',
    publishDate: '2024-05-27',
    url: 'https://dzone.com/articles/exploring-innovative-paths-in-data-integration',
    image: {
      url: '/img/contentful/4zgczv2I-dz_cropped.webp',
      file: {
        url: '/img/contentful/4zgczv2I-dz_cropped.webp'
      }
    }
  },
  {
    id: '3Qqi34iKRdihFHCmJT01rH',
    internalTitle: 'Flatfile announces new data exchange platform',
    title: 'Flatfile announces new data exchange platform',
    publishDate: '2023-07-12',
    url: 'https://sdtimes.com/data/flatfile-announces-new-data-exchange-platform/',
    image: {
      url: '/img/contentful/4i1waWip-sdtimeslogo.webp',
      file: {
        url: '/img/contentful/4i1waWip-sdtimeslogo.webp'
      }
    }
  },
  {
    id: 'yCT5RUabQJ9IVXO0dNMMD',
    internalTitle:
      'Document onboarding startup Flatfile nabs $50M from investors, including Workday',
    title:
      'Document onboarding startup Flatfile nabs $50M from investors, including Workday',
    publishDate: '2022-09-27',
    url: 'https://techcrunch.com/2022/09/27/document-onboarding-startup-flatfile-nabs-50m-from-investors-including-workday/',
    image: {
      url: '/img/contentful/2cqmVrQM-z2yb0lc1dci3dalkwcvj.webp',
      file: {
        url: '/img/contentful/2cqmVrQM-z2yb0lc1dci3dalkwcvj.webp'
      }
    }
  },
  {
    id: 'gNSW5yRLt0vELwfqmYq7K',
    internalTitle: 'Flatfile Closes $50M Tiger-Led Series B',
    title: 'Flatfile Closes $50M Tiger-Led Series B',
    publishDate: '2022-09-27',
    url: 'https://news.crunchbase.com/venture/funding-rounds-customer-management-flatfile/',
    image: {
      url: '/img/contentful/6JDBvkZh-crunchbase-logo.webp',
      file: {
        url: '/img/contentful/6JDBvkZh-crunchbase-logo.webp'
      }
    }
  }
]
